import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import "firebase/storage";

const configOptions = {
  apiKey: "AIzaSyBO7DR_jSm4wdQPY6Twx5fUFovM4ty-nC4",
  authDomain: "atlas-18495.firebaseapp.com",
  databaseURL: "https://atlas-18495.firebaseio.com",
  projectId: "atlas-18495",
  storageBucket: "atlas-18495.appspot.com",
  messagingSenderId: "485712095762",
  appId: "1:485712095762:web:66a4d1d99d1ab8439e46cb",
  measurementId: "G-FMR2XBZ2E2",
};

firebase.initializeApp(configOptions);
firebase.analytics();

export default {
  auth: firebase.auth(),
  getFirestore() {
    return firebase.firestore();
  },
  getStorage() {
    return firebase.storage();
  },
  login(email, password) {
    // const provider = new firebase.auth.GoogleAuthProvider();
    // firebase
    //   .auth()
    //   .signInWithPopup(provider)
    //   .then(function(result) {
    //     console.log(result);
    //   })
    //   .catch(function(error) {
    //     const errorCode = error.code;
    //     const errorMessage = error.message;
    //     const email = error.email;
    //     const credential = error.credential;
    //     console.log(errorCode, errorMessage, email, credential);
    //   });

    return firebase.auth().signInWithEmailAndPassword(email, password);
  },
  logout() {
    return firebase.auth().signOut();
  },
};
